<template>
    <div v-loading="loadingTemplate">
           <el-tabs v-model="activeTab" type="border-card" @tab-click="tabClick">
            <!-- TAB User -->
			<el-tab-pane label="User" name="user">
                <el-row :gutter="10" v-if="!showAlert" style="z-index: 0" v-loading="loadingMember">
                    <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card shadow="card-shadow--small">
                            <el-pagination
                                background
                                prev-text="Prev"
                                next-text="Next"
                                layout="prev, pager, next"
                                :page-size="20"
                                @current-change="paginate"
                                :current-page="currentPage"
                                :total="totalMember">
                            </el-pagination><br>
                            <br>
                            <div class="group-list scrollable only-y">
                                <template>
                                    <el-table :data="listMember" style="width: 100%" v-loading="loadingTableMember" element-loading-text="Loading..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(246, 246, 245, 0.8)">
                                        <el-table-column prop="created_at" label="Register Date" width="250">
                                            <template slot-scope="prop">
                                                {{ formatDate(prop.row.created_at, "DD MMM YYYY, HH:mm") }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="email" label="Email" width="320" />
                                        <el-table-column prop="username" label="Username" width="200" />
                                        <el-table-column label="Account Level" width="200">
                                            <template slot-scope="prop">
                                                <el-tag type="danger" v-if="prop.row.is_pic == 1"><i class="mdi mdi-chess-king" /> PIC</el-tag>
                                                <el-tag type="default" v-else><i class="mdi mdi-chess-pawn" /> Default Member</el-tag>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="user_id" label="#" width="150" fixed="right">
                                            <template slot-scope="prop">
                                                <el-tooltip placement="top" :open-delay="2000">
                                                    <div slot="content">Send reset password email</div>
                                                    <el-button type="default" @click="dialogReset(prop.row)" size="mini"><i class="mdi mdi-lock-open" /> </el-button>
                                                </el-tooltip>
                                                <el-tooltip placement="top" :open-delay="2000">
                                                    <div slot="content">Remove user from panel</div>
                                                    <el-button type="danger" @click="dialogDelete(prop.row)" size="mini"><i class="mdi mdi-account-remove" /> </el-button>
                                                </el-tooltip>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </div><br/>
                            <el-pagination
                                background
                                prev-text="Prev"
                                next-text="Next"
                                layout="prev, pager, next"
                                :page-size="20"
                                @current-change="paginate"
                                :current-page="currentPage"
                                :total="totalMember">
                            </el-pagination>
                        </el-card>
                    </el-col>
                </el-row>
            
                 <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-else></el-alert>
                <el-dialog title="Confirmation" :visible.sync="showDialogReset" width="30%">
                    <span>This user's email (<b>{{ selectedRows.email }}</b>) will receive an email with link for reset password. Link will expired in 24 hour. Send this user an email for reset password?</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="sendEmailResetPassword" type="primary" :loading="loadingBtnReset">Send email</el-button>
                        <el-button @click="showDialogReset = false">Cancel</el-button>
                    </span>
                </el-dialog>
                <el-dialog title="Confirmation" :visible.sync="showDialogDelete" width="30%">
                    <span>This user (<b>{{ selectedRows.email }}</b>) will fully remove from DAM Corp Panel. Are you sure want to do this?</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="deleteUser" type="danger" :loading="loadingBtnDelete">Delete</el-button>
                        <el-button @click="showDialogDelete = false">Cancel</el-button>
                    </span>
                </el-dialog>
			</el-tab-pane>
            <!-- TAB Division -->
			<el-tab-pane label="Division" name="division">
                <el-row :gutter="10" class="mb-20" v-if="!showAlert" style="z-index: 0" v-loading="loadingTabDivision">
                    <el-card>
                        <el-button type="primary" @click="doShowDialogNewDivision()" :loading="loadingAddTemplate">New Division</el-button>
                    </el-card>
                </el-row>
                <el-alert title="Info" type="info" :closable="false" description="No Data" show-icon v-if="division.data.length == 0"></el-alert>
                <div v-else>
                    <el-card>
                        <div class="group-list scrollable only-y">
                            <template>
                                <el-table :data="division.data" v-loading="loadingTableDivision" style="width: 100%">
                                    <el-table-column prop="createdAt" label="Created At" width="200">
                                        <template slot-scope="props">
                                            <p style="font-weight:bold;">{{ formatDate(props.row.createdAt) }}</p>
                                        </template>
                                    </el-table-column>
                                    
                                    <el-table-column prop="divisionName" label="Division Name" width="250">
                                        <template slot-scope="props">
                                            <p style="font-weight:bold;">{{ props.row.divisionName }}</p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="picName" label="PIC Name" width="150">
                                        <template slot-scope="props">
                                            <p style="font-weight:bold;">{{ props.row.picName }}</p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="totalAssignedTemplate" label="Total Template" width="150">
                                        <template slot-scope="props">
                                            <p style="font-weight:bold;">{{ props.row.totalAssignedTemplate }}</p>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Operations" width="450">
                                        <template slot-scope="props">
                                            <el-button @click="handleClickViewDivision(props.row.divisionName)"
                                            :loading="division.buttonLoadingViewDivision" type="default" size="small"><i class="mdi mdi-plus" /> Assign Template</el-button>
                                            <el-button @click="handleClickUpdateDivision(props.row.divisionName,props.row.picName)" :loading="division.buttonLoadingUpdateDivision" type="primary" size="small"><i class="mdi mdi-border-color" /> Edit Division</el-button>
                                            <el-button @click="handleClickDeleteDivision(props.row.customerId,props.row.divisionName)" type="danger" size="small"><i class="mdi mdi-delete" /> Delete Division</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </div>
                        <el-pagination
                            background
                            prev-text="Prev"
                            next-text="Next"
                            layout="prev, pager, next"
                            :page-size="10"
                            @current-change="paginateDivision"
                            :current-page="divisionCurrentPage"
                            :total="totalDivision">
                        </el-pagination>
                    </el-card>
                </div>
			</el-tab-pane>
      	</el-tabs>
        <el-dialog title="Confirmation" :visible.sync="showDialogDeleteDivision" width="30%">
            <span>This division (<b>{{ selectedDeleteDivisionName }}</b>) will fully remove from DAM Corp Panel. Are you sure want to do this?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="deleteDivision" type="danger" :loading="loadingBtnDeleteDivision">Delete</el-button>
                <el-button @click="showDialogDeleteDivision = false">Cancel</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Division" :visible.sync="dialogNewDivision">
            <el-form>
                <el-form-item label="Division Name">
                    <el-input type="text" v-model="division.divisionName"></el-input>
                </el-form-item>
                <el-form-item label="PIC Name">
                    <el-input type="text" v-model="division.picName"></el-input>
                </el-form-item>
                 <!-- <el-form-item label="Template" v-for="index in totalDivisionTemplate" :key="index">
                    <el-select
                        filterable
                        v-model="selectedHsm" placeholder="Select template to assigned" :loading="loadingListHsm" style="width: 100%">
                        <el-option
                            v-for="(template, key) in hsmList" :key="key"
                            :label="template.name"
                            :value="template._id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="totalDivisionTemplate+=1">+</el-button>
                </el-form-item> -->
                <el-button type="primary" @click="createDivision" :loading="division.buttonLoadingCreate">Save</el-button>
                <el-button type="danger" @click="dialogNewDivision=false">Close</el-button>
            </el-form>
        </el-dialog>
        <el-dialog :title="'Edit Division ' + selectedDivision" :visible.sync="dialogUpdateDivision">
            <el-form>
                <el-form-item label="Insert a new Division Name">
                    <el-input type="text" v-model="selectedDivision"></el-input>
                </el-form-item>
                <el-form-item label="PIC Name">
                    <el-input type="text" v-model="selectedDivisionPic"></el-input>
                </el-form-item>
                <el-button type="primary" @click="updateDivision" :loading="division.buttonLoadingEdit">Save</el-button>
                <el-button type="danger" @click="dialogUpdateDivision=false">Close</el-button>
            </el-form>
        </el-dialog>
        <el-dialog :title="selectedDivision" :visible.sync="dialogViewDivision" style="margin:0 auto; width: 80%">
            <el-form >
                <el-form-item>
                <el-row :gutter="10" v-if="!showAlert" style="z-index: 0" v-loading="loadingDivision">
                    <el-col class="mt-10" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <el-card shadow="card-shadow--small">
                            <div class="group-list scrollable only-y">
                                <template>
                                    <el-table :data="division.dataSelected" style="width: 100%;" v-loading="loadingTableDetailDivision">
                                            <el-table-column prop="templateName" label="Template Name" width="500" />
                                            <el-table-column prop="templateId" label="#" width="115">
                                                <template slot-scope="props">
                                                    <el-button size="small" type="danger" class="mdi mdi-delete" @click="deleteAssignedTemplate(props.row.templateId)" :loading="division.buttonLoadingDelete"></el-button>
                                                </template>
                                            </el-table-column>
                                    </el-table>
                                </template>
                            </div><br/>
                            <el-pagination
                                background
                                prev-text="Prev"
                                next-text="Next"
                                layout="prev, pager, next"
                                :page-size="10"
                                @current-change="paginateDivisionTemplate"
                                :current-page="divisionTemplateCurrentPage"
                                :total="division.dataSelectedLength"
                                style="margin-top: 10px">
                        </el-pagination>
                        </el-card>
                    </el-col>
                </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button  :loading="division.buttonLoadingAssignTemplate" @click="handleClickAssignTemplate(selectedDivision)" type="primary">Add</el-button>
                    <el-button class="mt-10" type="danger" @click="dialogViewDivision=false;division.dataSelected=[]">Close</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="Assign Template" :visible.sync="dialogAssignTemplate" style="width: 70%;margin: 0 auto">
            <el-form label-width="80px">
                <!-- <el-form-item label="Number" >
                    <el-select
                        filterable
                        v-model="selectedPhoneNumber" @change="filterNumberChange" placeholder="Select number" style="width: 100%">
                        <el-option
                            v-for="(data, key) in waUserDetail.sender" :key="key"
                            :label="data"
                            :value="data">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="Template">
                    <el-select
                        filterable
                        v-model="selectedHsm" placeholder="Select template to assigned" :loading="loadingListHsm" style="width: 100%">
                        <el-option
                            v-for="(template, key) in hsmList" :key="key"
                            :label="template.name"
                            :value="template._id"
                            :disabled="hsmAssigned(template._id) ? true : false">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="createAssignTemplate" :loading="assignTemplate.buttonLoading">Save</el-button>
                    <el-button type="danger" @click="dialogAssignTemplate=false">Close</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
import api from '@/networkClient'
import config from '@/config'
const moment = require('moment')

export default {
    props: {
        waUserDetail: {
            type: Object
        },
        detail:{
            type: Object,
            default: {}
        },
        datahsm: {
            type: Array
        },
        customerName: {
            type: String
        },
        loadingTemp: {
            type: Boolean,
            default: false
        },
        loadingListHsmTemp: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loadingMember: false,
            loadingTabDivision: false,
            loadingDivision: false,
            loadingTableMember: false,
            loadingTableDivision: false,
            loadingTableDetailDivision: false,
            loadingBtnReset: false,
            loadingBtnDelete: false,
            loadingBtnDeleteDivision: false,
            showAlert: false,
            showDialogReset: false,
            showDialogDelete: false,
            showDialogDeleteDivision: false,
            listMember: [],
            totalMember: 0,
            currentPage: 1,
            totalDivision: 0,
            totalDivisionTemplate: 1,
            divisionCurrentPage: 1,
            divisionTemplateCurrentPage: 1,
            selectedRows: { email : "" },
            userDetail: { hsm: [] },
            divisionDetail: { hsm:[] },
            loadingAddTemplate: false,
            loadingUnassignedTemplate: false,
            selectedPhoneNumber: '',
            selectedHsm: '',
            selectedPhoneNumberUnassigned: '',
            selectedHsmUnassigned: '',
            selectedOldDivision: '',
            selectedDivision: '',
            selectedDivisionPic: '',
            selectedUpdateDivisionName: '',
            selectedUpdateDivisionPicName: '',
            selectedDeleteDivisionName: '',
            selectedDeleteUserIdDivisionName: '',
            loadingTemplate: this.loadingTemp,
            loadingListHsm: this.loadingListHsmTemp,
            hsmUser:[],
            number: [],
            consumen: {},
            hsmList: this.datahsm,
            activeTab: 'user',
            dialogNewDivision: false,
            dialogUpdateDivision: false,
            dialogViewDivision: false,
            dialogAssignTemplate: false,
            assignTemplate: {
                data: [],
                loading: false,
                buttonLoading: false
            },
            assignNewTemplate: {
                data: [],
                loading: false,
                buttonLoading: false
            },
            division: {
                dataSelected: [],
                dataSelectedLength: 0,
                data: [],
                divisionName: '',
                picName: '',
                loading: false,
                buttonLoadingCreate: false,
                buttonLoadingEdit: false,
                buttonLoadingDelete: false,
                buttonLoadingAssignTemplate: false,
                buttonLoadingViewDivision: false,
                buttonLoadingUpdateDivision: false,
                buttonLoadingDeleteDivision: false
            },
            assignedHsmDivision : []
        }
    },
    methods: {
        hsmAssigned(id){
            return _.find(this.assignedHsmDivision, (v) => {
                return v.templateId == id
            })
        },
        paginate(page){
            this.currentPage = page
            this.loadMember(page)
        },
        paginateDivision(page){
            this.divisionCurrentPage = page
            this.getDivision(page)
        },
        paginateDivisionTemplate(page){
            this.divisionTemplateCurrentPage = page
            this.getDivisionDetail(page)
        },
        dialogReset(row){
            this.selectedRows = row
            this.showDialogReset = true
        },
        dialogDelete(row){
            this.selectedRows = row
            this.showDialogDelete = true
        },
        // hsmAssigned(id){
        //     return _.find(this.userDetail.hsm, (v) => {
        //         return v._id == id
        //     })
        // },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        formatDate(val, format){
            return moment(val).format('DD-MM-YYYY hh:mm:ss')
        },
        doShowDialogNewDivision(){
            this.dialogNewDivision = true
            // this.getAllHSM()

        },
        handleClickViewDivision(division){
            this.division.buttonLoadingViewDivision = true
            this.selectedDivision = division
            this.getDivisionDetail()
            this.getAllHSM()
            this.division.buttonLoadingViewDivision = false
            this.dialogViewDivision = true
        },
        handleClickUpdateDivision(division,pic){
            this.division.buttonLoadingUpdateDivision = true
            this.selectedOldDivision = division
            this.selectedDivision = division
            this.selectedDivisionPic = pic
            this.getDivisionDetail()
            this.division.buttonLoadingUpdateDivision = false
            this.dialogUpdateDivision = true
        },
        handleClickDeleteDivision(userId,division){
            this.selectedDeleteUserIdDivisionName = userId
            this.selectedDeleteDivisionName = division
            this.showDialogDeleteDivision = true
        },
        handleClickAssignTemplate(division){
            this.division.buttonLoadingAssignTemplate = true
            this.selectedDivision = division
            this.division.buttonLoadingAssignTemplate = false
            this.dialogAssignTemplate = true
        },
        closeAssignTemplate(){
            this.selectedPhoneNumber = ''
            this.selectedHsm = ''
            this.dialogAssignTemplate=false
            this.getDivisionDetail()
        },
        async deleteAssignedTemplate(templateId){
            let custId = this.$route.params.consumen
            let templateName = _.find(this.hsmList, hsm => { return hsm._id == templateId }).name
             this.$confirm(`Are you sure want to unassigned <b>${templateName}</b> from this number?`, 'Confirm', {
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                type: 'warning',
                center: true,
                dangerouslyUseHTMLString: true,
			}).then(async () => {
                this.division.buttonLoadingDelete = true
                await api({
                    url:config.baseApi+'division/unassign_template/'+custId,
                    method:'POST',
                    data: {
                        divisionName: this.selectedDivision,
                        template:[{
                            templateName : templateName,
                            templateId : templateId
                        }]
                        }
                        
                }).then(response => {
                    if(response.data.ec != 200){
                        this.$swal(this.$t('error'), this.$t('error_text'), "error")
                    } else {
                        this.$swal(this.$t('success'), this.$t('success_text'), "success")
                        this.getDivision(this.divisionCurrentPage)
                        this.getDivisionDetail()

                    }
                }).catch(error => {
                })
                this.division.buttonLoadingDelete = false
                }).catch(cancel => {
            })
        },
        async updateDivision(){
            if(this.selectedDivision == '' || this.selectedDivisionPic == ''){
                this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
            } else {
                this.division.buttonLoadingEdit = true
                let custId = this.$route.params.consumen
                await api({
                    method:'POST',
                    url:config.baseApi+'division/update/'+custId+'/'+this.selectedOldDivision+'/'+this.selectedDivisionPic,
                    data:{
	                    divisionName: this.selectedDivision,
	                    picName: this.selectedDivisionPic
                    }
                }).then(res => {
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), "Update division failed.", "error").then(() => {})
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {})
                        this.dialogUpdateDivision = false
                        this.selectedDivision = ''
                        this.selectedDivisionPic = ''
                        this.getDivision(this.divisionCurrentPage)
                    }
                }).catch(err => {
                    console.log('error',err.message)
                })
                this.division.buttonLoadingEdit = false
            }
        },
        async deleteDivision(){
            this.loadingBtnDeleteDivision = true
            await api({
                url:config.baseApi+'division/remove/'+this.selectedDeleteUserIdDivisionName,
                method:'POST',
                data: {
                    divisionName: this.selectedDeleteDivisionName
                }
            }).then(response => {
                if(response.data.ec != 200){
                    this.$swal(this.$t('error'), this.$t('error_text'), "error")
                } else {
                    this.$swal(this.$t('success'), this.$t('success_text'), "success")
                    this.getDivision()
                }
            }).catch(error => {
                console.log(error)
            })         
            this.loadingBtnDeleteDivision = false
            this.showDialogDeleteDivision = false
        },

        clear(){
			this.selectedPhoneNumber = ''
            this.selectedHsm = ''
            this.selectedPhoneNumberUnassigned = ''
            this.selectedHsmUnassigned = ''
            this.selectedDivision= ''
            this.division.dataSelected=''
        },
        async sendEmailResetPassword(){
            this.loadingBtnReset = true
            await api({
                method: 'post',
                url: 'consumen/' + this.$route.params.consumen + "/member/send-reset-password",
                data: {
                    email: this.selectedRows.email
                }
            }).then(result => {
                if(result.data.ec == 200){
                    this.showDialogReset = false
                    this.$swal({
						title: this.$t('success'),
						text: '',
						type: 'success',
					})
                } else{
                    this.$message.warning({
						showClose: false,
						message: this.$t(`error_text`)
					});
                }
            }).catch(err => {
                 this.$message.error({
                    showClose: false,
                    message: this.$t(`error_text`)
                });
            })
            this.loadingBtnReset = false
        },
        async deleteUser(){
            this.loadingBtnDelete = true
            await api({
                method: 'delete',
                url: 'consumen/' + this.$route.params.consumen + "/member/",
                data: {
                    email: this.selectedRows.email,
                    operator: this.selectedRows.operatorId,
                    number: this.selectedRows.operatorNumber
                }
            }).then(result => {
                if(result.data.ec == 200){
                    this.showDialogDelete = false
                    this.$swal({
						title: this.$t('success'),
						text: '',
						type: 'success',
                    })
                    this.loadMember()
                } else{
                    this.$message.warning({
						showClose: false,
						message: this.$t(`error_text`)
					});
                }
            }).catch(err => {
                 this.$message.error({
                    showClose: false,
                    message: this.$t(`error_text`)
                });
            })
            this.loadingBtnDelete = false
        },
        async loadMember(page = 1){
            this.loadingMember = true
            await api({
                method: 'get',
                url: 'consumen/' + this.$route.params.consumen + "/member",
                params: {
                    page: page
                }
            }).then(result => {
                if(result.data.ec == 200){
                    this.listMember = result.data.data.user
                    this.totalMember = result.data.data.total
                } else{

                }
            }).catch(err => {

            })
            this.loadingMember = false
        },
        async getAllHSM(){
            this.loadingListHsm = true
			var self = this      
			await api({
				url:config.baseApi+'get_hsm',
				method:'GET'
			}).then(response => {
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), this.$t('error_text'), "error")
				} else {
                    this.hsmList = response.data.data
				}
				// this.loadingTemplate = false
			}).catch(error => {
				// this.loadingTemplate = false
            })
            this.loadingListHsm = false
		},
        async loadWA() {
			let custId = this.$route.params.consumen
			await api({
				method: 'post',
                url: config.baseApi +'user/'+custId+'/detail_one',
                data: {
                    number: this.selectedPhoneNumber
                }
			}).then(result => {
                this.hsmUser = result.data.data
                this.userDetail = { detail: [], hsm: [], sender: [] }
				if(result.data.ec == 200){
                    this.userDetail = result.data.data
                    this.userDetail.hsm = _.remove(result.data.data.hsm, (v) => { return _.isEmpty(v) == false })
                    this.getAllHSM()
				} else if(result.data.ec == 400 && result.data.message == "not_subscribe"){
					this.showAlertMessage = true
				} else {
					this.showAlertError = true
				}
			}).catch(error => {
				this.showAlertError = true
            })
            this.loadingTemplate = false
        },
        async filterNumberChange(){
            this.loadWA()
        },
        async getDivision(page){
            this.loadingTableDivision = true
            var custId = this.$route.params.consumen
            await api({
                methods: 'get',
                url: config.baseApi+'division/list/'+custId+'?page='+page
            }).then(response => {
                this.division.data = _.isEmpty(response.data.data) ? [] : response.data.data
                // this.totalDivision = 100
                this.totalDivision = parseInt(response.data.total)
                let templateAssigned = []
				_.forEach(response.data.data , tempPerDiv => {
					_.forEach(tempPerDiv.template, temp => {
						templateAssigned.push(temp)
					})
				})
				this.assignedHsmDivision = templateAssigned
				this.totalDivision = parseInt(response.data.total)
            }).catch(error => {
                console.log(error)
            })
            this.loadingTableDivision = false
        },
        async getDivisionDetail(page=1){
            this.loadingTableDetailDivision = true
            let custId = this.$route.params.consumen
            let divName = this.selectedDivision
            await api({
                methods: 'get',
                url: `${config.baseApi}division/list/${custId}/${divName}?page=${page}`
            }).then(response => {
                this.division.dataSelected = response.data.data.template
                this.division.dataSelectedLength = parseInt(response.data.total)
            }).catch(error => {
                console.log(error)
            })
            this.loadingTableDetailDivision = false
        },
        async createDivision(){
            if(this.division.divisionName == '' || this.division.picName == ''){
                this.$message.error({
					showClose: false,
					message: 'All field is required'
				});
				return
            } else {
                this.division.buttonLoadingCreate = true
                let custId = this.$route.params.consumen
                await api({
                    method:'post',
                    url:config.baseApi+'division/create',
                    data:{
                        customerId: custId,
                        divisionName: this.division.divisionName,
                        picName: this.division.picName,
                        template: [{
                            templateName: '',
                            templateId: ''
                        }]
                    }
                }).then(res => {
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), "Create division failed.", "error").then(() => {})
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {})
                        this.dialogNewDivision = false
                        this.division.divisionName = ''
                        this.division.picName = ''
                        this.getDivision()
                    }
                    this.division.buttonLoadingCreate = false
                }).catch(err => {
                    console.log('error',err.message)
                })
            }
        },
        async createAssignTemplate(){
            let custId = this.$route.params.consumen
            let templateName = _.find(this.hsmList, hsm => { return hsm._id == this.selectedHsm }).name
                this.assignTemplate.buttonLoading = true
                await api({
                    method:'post',
                    url:config.baseApi+'division/assign_template/'+custId,
                    data:{
                        divisionName: this.selectedDivision,
                        template: [{
                            templateName: templateName,
                            templateId: this.selectedHsm
                        }]
                    }
                }).then(res => {
                    if(res.data.ec != 200){
                        this.$swal(this.$t('error'), "Assign Template failed.", "error").then(() => {})
                    } else {
                        this.$swal(this.$t('success'), this.$t('success'), "success").then(() => {})
                        this.dialogAssignTemplate = false
                        this.selectedPhoneNumber = ''
                        this.selectedHsm = ''
                        this.getDivisionDetail()
                        this.getDivision()
                    }
                    this.assignTemplate.buttonLoading = false
                }).catch(err => {
                    console.log('error',err.message)
                })
        },
        tabClick(target){
            if(target.name == 'user'){
                this.loadMember()
            } else if(target.name == 'division'){
                this.loadingTableDivision = true
                this.getDivision()
            }
        }
    },
    mounted(){
        this.loadMember()
        this.getDivision()
    },
    watch: {
        loadingPage: function(){
            this.loadingMember = this.loadingPage
            this.listMember = this.list.user
            this.totalMember = this.list.total
        }
    }
}
</script>